import { useEffect, useState } from "react";

/**
 * Custom hook to track viewport height
 * Prevents SSR issues and updates on resize
 */
export const useViewportHeight = () => {
  const [viewportHeight, setViewportHeight] = useState(() =>
    typeof window === "undefined" ? 0 : window.innerHeight
  );

  useEffect(() => {
    const updateViewportHeight = () => {
      if (typeof window === "undefined") return;
      setViewportHeight(window.innerHeight);
    };

    updateViewportHeight();
    window.addEventListener("resize", updateViewportHeight);
    return () => window.removeEventListener("resize", updateViewportHeight);
  }, []);

  return viewportHeight;
};
